//import Moment from "moment";

const getCount = (state) => {
	return state.planosManutencao.length;
}

const ultimaAtualizacaoListaPlanoManutencao = (state) => {
	if (state.ultimaAtualizacaoListaPlanoManutencao == null) {
		return true;
	}
	else if(!state.planosManutencao)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.planosManutencao.length == 0 ||
			hour - state.ultimaAtualizacaoListaPlanoManutencao.getHours() > 0
		);
	}
}

export default {
	getCount,
	ultimaAtualizacaoListaPlanoManutencao
}